import React, { Component, PureComponent } from 'react';
import {NavLink, Link} from 'react-router-dom'
import './index.scss'
import Specials from './Specials'
import Catering from './Catering'
import OurStory from './OurStory'
import CartBar from './CartBar'
import './altStyleA.scss'
// import AutoMenu from './AutoMenu'
export { Specials as special }
export { Catering as catering }

// export { OurStory as about }

// "/" and "/menu" belong to the Astro marketing site in production (see
// ./_redirects); this app only owns the ordering routes. /special and /catering
// are still real pages here — they are registered through `pages` below, not
// through this list, which only controls where AutoMenu renders.
export const customOrderAppPaths = ["/order"]

export {CartBar as StickyTopBar}

export const pages = [
  {path: "/order", label: "Order"},
  {path: "/special", label: "Coupons", component: Specials},
  {path: "/catering", label: "Catering", component: Catering},
  // {path: "/about", label: "Our Story", component: OurStory},
]

export class SiteNav extends PureComponent {
  render() {

    return (
    <nav className="pages-nav">
      <ul>
        {pages.map(({path, label}) => (
          <li><NavLink className="page-link" to={path}>{label}</NavLink></li>
        ))}
      </ul>
    </nav>
  )}
}

export class OrderingHeader extends PureComponent {
  render() {
    return (
      <div className="order-benefits-wrapper">
        <div className="order-benefits">

          <div
            className="text"
             >


            <p>Order Togo & Delivery</p>
          </div>
        </div>
      </div>
    );
  }
}
// logo link: https://d2abh92eaqfsaa.cloudfront.net/image/upload/u7ryxhrj9dapgz8pqmny
//
// App.js renders this at "/" exact — a route Netlify rewrites to the Astro
// marketing homepage before React ever loads, so in production this component
// is unreachable. It is kept only so `npm start` still has something at "/".
export class Header extends PureComponent {
  render() {
    return (
      <div className="landing-page-wrapper">

        <div className="sections-wrapper">
          <section className="section banner">
            <div className="content"
              style={{
                backgroundImage: `url(https://images.unsplash.com/photo-1552580715-4d9bc27f1e2f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80)`,
              }}
              >
                <div className="text">
                  <h1><span className="bg">Hand Tossed Pizza.</span></h1>
                  <div className="button-wrapper">
                    <Link
                      className="order-online-button"
                      to="/order">Order Online
                    </Link>
                  </div>
                </div>

              </div>
          </section>

          <section className="section">
            <div className="content"
              style={{
                backgroundImage: `url(https://images.unsplash.com/photo-1499778003268-cbafc6d08bab?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=650&q=80)`,

              }}
              >
              <div className="text">
                <h2>Menus</h2>
                <Link to="/menu">view menu</Link>
              </div>
            </div>
          </section>

          <section className="section">
            <div className="content"
              style={{
                backgroundImage: `url(https://images.unsplash.com/photo-1551978155-63d44a16fe24?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=650&q=80)`,

              }}
              >
              <div className="text">
                <h2>Catering</h2>
                <Link to="/catering">view catering</Link>
              </div>
            </div>
          </section>

          <section className="section">
            <div className="content"
              style={{
                backgroundImage: `url(https://s3-media2.fl.yelpcdn.com/bphoto/_M_fSY_gfpArtUj3xEUorA/o.jpg)`,

              }}
              >

              <div className="text">
                <h2>Visit Us</h2>
                <a href="https://www.google.com/maps/place/13762+Clark+Ave,+Bellflower,+CA+90706/data=!4m2!3m1!1s0x80c2cd4739ffe2d1:0x86261b4735509277?sa=X&hl=en&ved=2ahUKEwiym4i7kI3jAhWHQs0KHRmQCIwQ8gEwAHoECAoQAQ">13762 Clark Ave, Bellflower</a>
                {/* <p>Glendale, CA 91206</p> */}
                {/* <small><a href="tel:+18182400020">(818)240-0020</a></small> */}
              </div>
            </div>
          </section>
        </div>



        {/* <div className="order-benefits home">

          <div
            className="text"
             >
           <h1><img style={{width: "125px"}}
             src="https://d2abh92eaqfsaa.cloudfront.net/image/upload/u7ryxhrj9dapgz8pqmny" alt="Two Guys from Italy — Glendale"/></h1>
            <small>405 N Verdugo Rd Glendale, CA</small><br/>
            <small><a href="tel:+18182400020">(818)240-0020</a></small>

          </div>
        </div> */}
      </div>
    );
  }
}

const foodImages = [
  'https://afag.imgix.net/two-guys-from-italy-glendale/meat-balls-pasta.jpg?w=800&auto=compress',
  'https://afag.imgix.net/two-guys-from-italy-glendale/porchiuto.jpg?w=800&auto=compress',
  'https://afag.imgix.net/two-guys-from-italy-glendale/pizza.jpg?w=800&auto=compress',
  'http://www.glendaletwoguysfromitaly.com/img/carousel/home_bg_d.jpg',
  'http://www.glendaletwoguysfromitaly.com/img/carousel/home_bg_e.jpg'
]


export function subMenuFilter (subMenu) {
  const tag = subMenu.tag
  if (!tag) {return true}

  const now = new Date()
  const day = now.getDay() // Sunday - Saturday : 0 - 6
  const hours = now.getHours() //0 to 23
  const minutes = now.getMinutes() // 0 to 59
  const isWeekday = [1,2,3,4,5].indexOf(day) !== -1
  const isLunch = (
    (hours >= 0) && (hours < 15)
  )
  const showLunchMenu = isWeekday && isLunch

  const isLunchSubmenu = tag.indexOf('lunch') !== -1
  const isDinnerSubmenu = tag.indexOf('dinner') !== -1

  if (isLunchSubmenu) {
    if ((day === 0) || (day === 6)) {
      return false
    }
    if (hours < 15) {
      return true
    }
    if (hours === 15 && minutes < 30) {
      return true
    }
    return false
  }

  return true
}
